import { Database, BarChart3, Code, Brain, TrendingUp, Cloud, Zap } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface QuickFilterTagsProps {
  selectedTags: string[];
  onTagClick: (tag: string) => void;
}

const careerTags = [
  { label: "Analista de Dados", value: "data-analyst", icon: BarChart3 },
  { label: "Cientista de Dados", value: "data-scientist", icon: Brain },
  { label: "Engenheiro de Dados", value: "data-engineer", icon: Database },
  { label: "BI Analyst", value: "bi", icon: BarChart3 },
  { label: "Analytics Engineer", value: "analytics-engineer", icon: TrendingUp },
  { label: "Python", value: "python", icon: Code },
  { label: "SQL", value: "sql", icon: Database },
  { label: "Machine Learning", value: "ml", icon: Brain },
  { label: "Power BI", value: "powerbi", icon: BarChart3 },
  { label: "AWS", value: "aws", icon: Cloud },
  { label: "Spark", value: "spark", icon: Zap },
  { label: "Airflow", value: "airflow", icon: Zap },
];

export function QuickFilterTags({ selectedTags, onTagClick }: QuickFilterTagsProps) {
  return (
    <div className="mb-6">
      <p className="text-sm text-muted-foreground mb-3">Filtros rápidos:</p>
      <div className="flex flex-wrap gap-2">
        {careerTags.map((tag) => {
          const Icon = tag.icon;
          const isActive = selectedTags.includes(tag.value);
          
          return (
            <Badge
              key={tag.value}
              variant={isActive ? "default" : "outline"}
              className={cn(
                "cursor-pointer transition-all duration-200 hover:scale-105 px-3 py-1.5 text-sm",
                isActive && "shadow-sm"
              )}
              onClick={() => onTagClick(tag.value)}
            >
              <Icon className="h-3.5 w-3.5 mr-1.5" />
              {tag.label}
            </Badge>
          );
        })}
      </div>
    </div>
  );
}
